import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getInvestmentPerformance = createAsyncThunk(
  "performance/getInvestmentPerformance",
  async ({ clientId, investmentId }, { rejectWithValue }) => {
    try {
      const response = await getMethod(
        `/api/InvestmentDetails/${clientId}/${investmentId}`
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Failed to fetch performance data");
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Failed to fetch performance data"
      );
    }
  }
);

const initialState = {
  performance: null,
  loading: false,
  error: null,
  success: false,
};

const performanceSlice = createSlice({
  name: "performance",
  initialState,
  reducers: {
    clearPerformanceState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.performance = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getInvestmentPerformance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInvestmentPerformance.fulfilled, (state, action) => {
        state.loading = false;
        state.performance = action.payload?.data;
        state.success = true;
      })
      .addCase(getInvestmentPerformance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.performance=null;
        state.success = false;
      });
  },
});


export const { clearPerformanceState } = performanceSlice.actions;
export default performanceSlice.reducer;
